import React from 'react'
import { MultiSelect } from '@mantine/core'

import { STATES } from '@/utils/states'

const allStatesOptions = Object.keys(STATES).map(state => ({
  value: state,
  label: STATES[state],
}))

export const StateMultiSelect: React.FC<
  {
    value?: string[]
    onChange: (value: string[]) => void
  } & Omit<
    React.ComponentProps<typeof MultiSelect>,
    'value' | 'data' | 'onChange'
  >
> = ({ value = [], onChange, ...props }) => {
  return (
    <MultiSelect
      {...props}
      data={allStatesOptions}
      value={value}
      onChange={onChange}
      searchable
    />
  )
}
